
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Sevanseatercaronrent() {



    const cardData =
    {
        keyword: ' 7 Seater Car On Rent in Pune',
        heading: 'Prince Cabs: 7 Seater Car On Rent in Pune',
        headingDescription: 'Prince Cabs provides comfortable 7 Seater Car on Rent in Pune, perfect for family trips, corporate outings, airport transfers, and outstation journeys. Our spacious vehicles like Innova and Ertiga are well-maintained and equipped with modern amenities to ensure a safe and enjoyable ride. With professional chauffeurs, flexible schedules, and transparent pricing, we make group travel convenient and stress-free. Choose Prince Cabs’ trusted 7 seater car rental service in Pune for reliability, comfort, and affordability.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed in a fire, its massive gates, courtyards, and stone walls still narrate tales of Maratha glory. The evening light-and-sound show brings alive stories of valor and politics. Visitors enjoy strolling through its gardens and ruins. It is both a cultural and historical symbol of Pune. Shaniwar Wada remains the city’s most iconic heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic building with immense historical importance. During the Quit India Movement, Mahatma Gandhi and Kasturba Gandhi were imprisoned here. Today, it houses a museum with photographs, artifacts, and personal belongings of Gandhi. Its sprawling gardens add tranquility to the site. Recognized as a national monument, it reflects sacrifice and patriotism. It is one of Pune’s top heritage attractions."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 30 km from Pune, is famous for the 1670 Battle of Sinhagad led by Tanaji Malusare. Its bastions, watchtowers, and memorials narrate Maratha history. Trekkers love the scenic climb, especially in monsoon when waterfalls and mist cover the hills. The summit offers breathtaking Sahyadri views. Local stalls serving pithla-bhakri add rustic charm. Sinhagad is a perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious landmark, dedicated to Lord Ganesha. The idol is adorned with gold ornaments, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the cultural hub of the city. It is also known for charitable activities and community service. The temple is centrally located and easily accessible. It is a must-visit for spiritual seekers and cultural enthusiasts."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of Pune’s highest points, offering sweeping views of the city. At the top lies the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati. Visitors climb over 100 steps to reach the sacred site. The Peshwa Museum nearby showcases Maratha artifacts. Sunrises and sunsets from here are especially enchanting. It is a blend of spirituality, history, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, dating back to the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum with a Shiva linga, and a stone-carved Nandi. Despite its central location, it offers a calm, meditative environment. The temple reflects Rashtrakuta-era architecture. Tourists admire its simplicity and heritage charm. It is one of Pune’s hidden historical treasures."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include sculptures, musical instruments, paintings, and the famous recreated Mastani Mahal. The museum reflects India’s cultural richness and craftsmanship. It fascinates art lovers and historians alike. The three-story heritage building itself adds to the experience. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global spiritual retreat. Visitors from around the world come here for meditation, yoga, and wellness programs. Surrounded by serene gardens and modern facilities, it offers a peaceful escape. The ashram promotes holistic living and inner growth. Its international community adds cosmopolitan charm. It is a blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle mall. It houses hundreds of global and Indian brands, fine dining restaurants, and entertainment zones. Multiplex cinemas and gaming areas make it a family favorite. Seasonal events and festivals add vibrancy. It is a hub for shopping, leisure, and socializing. Phoenix Marketcity defines Pune’s modern urban lifestyle."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a popular picnic and weekend spot. It supplies water to the city and is surrounded by scenic hills. Families enjoy boating, street food, and evening walks by the reservoir. Monsoon transforms the area into a lush green paradise. Cool breezes make evenings especially refreshing. It is a peaceful natural retreat near the city."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by Mulshi Dam, is a serene getaway near Pune. Surrounded by Sahyadri hills, waterfalls, and forests, it is ideal for camping, boating, and nature photography. Monsoon enhances its beauty with misty valleys and overflowing streams. Eco-resorts nearby offer a peaceful stay. Couples and families love its tranquil vibe. Mulshi is both an adventurous and relaxing destination."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, located on Senapati Bapat Road, is one of Pune’s oldest shrines. Dedicated to Goddess Chaturshringi, devotees climb more than 100 steps to reach the sanctum. The temple is vibrant during Navratri with colorful festivities. Thousands of pilgrims visit year-round to seek blessings. Its hilltop location also provides panoramic views of Pune. It is a blend of faith and tradition."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial in Pune honors soldiers who laid down their lives post-independence. It showcases tanks, weapons, and war memorabilia. The museum inside educates visitors about India’s military history. The evening flag retreat ceremony is an inspiring experience. It instills patriotism in children and adults alike. The memorial is both emotional and educational."
  },
  {
    "title": "Empress Garden",
    "description": "Spread across 39 acres, Empress Garden is one of Pune’s oldest botanical parks. Managed by the Agri-Horticultural Society, it houses exotic plants, shaded walkways, and flower nurseries. Families come here for picnics and relaxation. The annual flower show is a highlight for nature enthusiasts. Its colonial history adds to its charm. Empress Garden is a peaceful green escape within the city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a favorite spot for joggers, trekkers, and cyclists. The hilltop offers panoramic views of the entire city. It is rich in biodiversity, with birds, trees, and fresh air. Locals gather here for morning yoga and fitness routines. Sunrises and sunsets are mesmerizing from this spot. Vetal Hill is Pune’s natural lung and a refreshing retreat."
  }
],

    "services": [
  {
    "name": "7 Seater Cab Booking Pune",
    "description": "Book 7 seater cabs in Pune for family trips, group travel, or outstation journeys. Enjoy spacious seating and a smooth ride experience."
  },
  {
    "name": "Innova Crysta 7 Seater Rental Pune",
    "description": "Rent Innova Crysta 7 seater in Pune for a premium travel experience. Ideal for families and corporate groups seeking comfort and class."
  },
  {
    "name": "Ertiga 7 Seater Car Hire Pune",
    "description": "Hire Ertiga 7 seater in Pune for economical and comfortable group travel. Suitable for both city rides and long-distance journeys."
  },
  {
    "name": "Family Car on Rent in Pune",
    "description": "Spacious and well-maintained family cars available for rent in Pune. Great for vacations, picnics, and outstation travel."
  },
  {
    "name": "SUV Car Hire Pune",
    "description": "Hire SUVs in Pune for powerful and comfortable travel. Ideal for rugged terrain and family outings."
  },
  {
    "name": "7 Seater Car Rental for Outstation Pune",
    "description": "Rent 7 seater cars in Pune for outstation trips with plenty of space and comfort for long-distance journeys."
  },
  {
    "name": "7 Seater Taxi Service Pune",
    "description": "Reliable 7 seater taxi services in Pune with experienced drivers and flexible rental options for local and outstation trips."
  },
  {
    "name": "Pune 7 Seater Cab for Picnic",
    "description": "Book a 7 seater cab in Pune for a relaxing and fun picnic trip. Spacious and comfortable travel for groups and families."
  },
  {
    "name": "Tempo Traveller 7 Seater Pune",
    "description": "Hire 7 seater Tempo Traveller in Pune for group tours and corporate travel. Ample space and a comfortable ride guaranteed."
  },
  {
    "name": "Affordable 7 Seater Car Pune",
    "description": "Affordable 7 seater car rental options in Pune that don't compromise on comfort or safety."
  },
  {
    "name": "AC 7 Seater Cab Pune",
    "description": "Enjoy air-conditioned 7 seater cabs in Pune for a cool and comfortable journey around the city or outstation."
  },
  {
    "name": "7 Seater Car Hire in Hinjewadi",
    "description": "7 seater car rentals available in Hinjewadi, Pune for family, office, or group travel. Easy booking and timely service."
  },
  {
    "name": "7 Seater for Pune to Mahabaleshwar",
    "description": "Book a 7 seater cab from Pune to Mahabaleshwar for a comfortable and scenic hill station getaway with your group or family."
  },
  {
    "name": "Pune to Mumbai 7 Seater Taxi",
    "description": "Hire a 7 seater taxi for Pune to Mumbai route with spacious seating and professional drivers for a safe and smooth ride."
  },
  {
    "name": "Best 7 Seater Rental Pune",
    "description": "Get the best 7 seater rental services in Pune with multiple vehicle options, affordable pricing, and reliable service."
  }
],
"tableData": [
  ["7 Seater Cab Booking Pune", "Innova Crysta 7 Seater Rental Pune"],
  ["Ertiga 7 Seater Car Hire Pune", "Family Car on Rent in Pune"],
  ["SUV Car Hire Pune", "7 Seater Car Rental for Outstation Pune"],
  ["7 Seater Taxi Service Pune", "Pune 7 Seater Cab for Picnic"],
  ["Tempo Traveller 7 Seater Pune", "Affordable 7 Seater Car Pune"],
  ["AC 7 Seater Cab Pune", "7 Seater Car Hire in Hinjewadi"],
  ["7 Seater for Pune to Mahabaleshwar", "Pune to Mumbai 7 Seater Taxi"],
  ["Best 7 Seater Rental Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Wide Choice of Comfortable 7‑Seater Vehicles",
    "WhyChoosedescription": "From the dependable Toyota Innova and Innova Crysta to modern MPVs like Kia Carens and Tempo Travellers, Prince Cabs offers a diverse range of 7‑seater vehicles—perfect for family trips, corporate outings, or comfortable outstation journeys."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Our rental rates are clear and affordable, ranging from ₹15–22 per km or ₹2,500–₹4,500 per day depending on the vehicle and plan. No hidden charges—pricing includes fuel, tolls, driver allowances, and taxes."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Every Need",
    "WhyChoosedescription": "Prince Cabs offers flexible rental plans including hourly, daily, one-way, round-trip, or multi-day bookings. You can book easily through phone, WhatsApp, or our website with instant confirmations and smooth support."
  },
  {
    "WhyChooseheading": "Well‑Maintained, Comfortable & Safe Vehicles",
    "WhyChoosedescription": "All our 7-seater cars are regularly cleaned, sanitized, and serviced. Vehicles are equipped with air-conditioning, ample legroom, and safety features like seat belts and airbags for a comfortable and secure ride."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar With Pune & Surroundings",
    "WhyChoosedescription": "Our professional drivers are familiar with routes in and around Pune, ensuring on-time pickups, efficient navigation, and safe long-distance travel to places like Shirdi, Mahabaleshwar, or Mumbai."
  },
  {
    "WhyChooseheading": "Cost‑Effective for Group Travel",
    "WhyChoosedescription": "Booking a 7‑seater is more affordable than hiring multiple cars, making it ideal for families or small groups who want to travel together comfortably and save on travel expenses."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Experience",
    "WhyChoosedescription": "Our support team is available round the clock to help with booking, changes, and inquiries—ensuring a smooth rental experience from start to finish."
  }
]
































    }

const faqData = [
    {
        question: 'Can I rent a 7-seater car in Pune with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers spacious and comfortable 7-seater cars for rent in Pune, ideal for family outings, group travel, and long-distance trips.',
    },
    {
        question: 'What types of 7-seater vehicles are available for rent in Pune?',
        answer: 'We provide popular 7-seater options like Toyota Innova, Maruti Ertiga, and Tempo Traveller, ensuring comfort and ample space for all passengers.',
    },
    {
        question: 'Is it possible to rent a 7-seater car for outstation trips from Pune?',
        answer: 'Absolutely! Our 7-seater rental service is perfect for outstation journeys, weekend getaways, and intercity travel from Pune.',
    },
    {
        question: 'Are the 7-seater rental cars sanitized and well-maintained?',
        answer: 'Yes, all our vehicles are regularly sanitized and undergo routine maintenance to guarantee a safe and pleasant travel experience.',
    },
    {
        question: 'Can I book a 7-seater car with a driver in Pune?',
        answer: 'Yes, you can rent a 7-seater car with a professional and experienced driver for local or outstation use in Pune.',
    },
    {
        question: 'What are the rental charges for a 7-seater car in Pune?',
        answer: 'Rental prices vary based on the car model, trip duration, and destination. Contact Prince Cabs for a customized and competitive quote.',
    },
    {
        question: 'How do I book a 7-seater car on rent in Pune?',
        answer: 'Booking is easy! Visit our website or call our customer service team to reserve your 7-seater car with quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Rajesh Jadhav",
        position: "Group Traveler",
        text: "We rented a 7-seater Innova from Prince Cabs for a weekend trip from Pune. The car was clean, spacious, and the service was excellent.",
        image: "/img/testimonial/testimonial-thumb-pune-7seater-1.png",
    },
    {
        name: "Mrs. Seema Joshi",
        position: "Family Trip Organizer",
        text: "Prince Cabs made our family travel from Pune comfortable and stress-free. Their 7-seater vehicle was in great condition and the driver was very polite.",
        image: "/img/testimonial/testimonial-thumb-pune-7seater-2.png",
    },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "7 Seater Car On Rent in Pune",
  "description": "Affordable and reliable 7 seater car rental services in Pune including Innova Crysta, Ertiga, and Tempo Traveller. Perfect for family trips, picnics, and outstation travel like Pune to Mahabaleshwar and Mumbai.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "7 Seater Cab Booking Pune",
    "Innova Crysta 7 Seater Rental Pune",
    "Ertiga 7 Seater Car Hire Pune",
    "Family Car on Rent in Pune",
    "SUV Car Hire Pune",
    "7 Seater Car Rental for Outstation Pune",
    "7 Seater Taxi Service Pune",
    "Pune 7 Seater Cab for Picnic",
    "Tempo Traveller 7 Seater Pune",
    "Affordable 7 Seater Car Pune",
    "AC 7 Seater Cab Pune",
    "7 Seater Car Hire in Hinjewadi",
    "7 Seater for Pune to Mahabaleshwar",
    "Pune to Mumbai 7 Seater Taxi",
    "Best 7 Seater Rental Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};






    return (
        <div>
<Helmet>
  <title>7 Seater Car On Rent in Pune | Innova, Ertiga & Tempo Traveller</title>
  <meta
    name="description"
    content="Affordable and reliable 7 seater car rental services in Pune including Innova Crysta, Ertiga, and Tempo Traveller. Ideal for family trips, picnics, and outstation travel."
  />
  <meta
    name="keywords"
    content="7 Seater Cab Booking Pune, Innova Crysta 7 Seater Rental Pune, Ertiga 7 Seater Car Hire Pune, Family Car on Rent in Pune, SUV Car Hire Pune, 7 Seater Car Rental for Outstation Pune, 7 Seater Taxi Service Pune, Pune 7 Seater Cab for Picnic, Tempo Traveller 7 Seater Pune, Affordable 7 Seater Car Pune, AC 7 Seater Cab Pune, 7 Seater Car Hire in Hinjewadi, 7 Seater for Pune to Mahabaleshwar, Pune to Mumbai 7 Seater Taxi, Best 7 Seater Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>

                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            {/* Sidebar routes (logo-colored UI) */}
<div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>




<div>
  <FleetHighway/>
</div>
                           <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sevanseatercaronrent ;